import { useEffect, useState } from "react";
import { useWorkspace } from "./workspace";

/** A company-local date, not an assertion that a fiscal period permits posting. */
export function OverviewCompanyDate() {
  const { legalEntity } = useWorkspace();
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const refresh = () => setNow(new Date());
    const timer = window.setInterval(refresh, 60_000);
    window.addEventListener("focus", refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  let date: string | undefined;
  if (legalEntity?.timeZone) {
    try {
      date = new Intl.DateTimeFormat("en-US", {
        timeZone: legalEntity.timeZone, month: "short", day: "numeric", year: "numeric",
      }).format(now);
    } catch {
      // Do not silently substitute the workstation's date for invalid company configuration.
    }
  }
  return <div className="period-chip">
    <span>Company date</span>
    <strong>{date ?? (legalEntity ? "Date unavailable" : "Select a company")}</strong>
    <small>{date ? legalEntity?.timeZone : legalEntity ? "Check company time zone" : "No company selected"}</small>
  </div>;
}
